import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actionsCreator } from 'redux/actions/actionsCreator';
//components
import AppWrapper from 'components/AppWrapper';
import AppLoader from 'components/AppLoader';
import DefaultBackground from 'components/DefaultBackground';
//APIs
import { configAPIs, proxyAPIs } from 'api';
//utils
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { setWindowObjectKey, checkIfInDebugMode } from 'utils';

const athenaFeatures = [
  'assessmentReportV2',
  'assessmentChannels',
  'assessmentSlug',
  'assessmentReportV3',
  'assessmentCarePlan',
  'availableWebAssessments',
];

const getConfigs = (data = {}) => {
  const configs = {};
  data.forEach((item = {}) => {
    const name = get(item, 'feature_name', '');
    const config = get(item, 'config', {});
    if (name) {
      configs[name] = { ...config, name };
    }
  });
  return configs;
};

/**
 * This wrapper will handle the configuration setup
 * It will fetch all configs and set it up in redux store.
 * After setting up everything it renders the children
 */
class PublicConfigWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }
  componentDidMount() {
    const { publicConfigData } = this.props;

    const isInDebugMode = checkIfInDebugMode();

    if (isInDebugMode || isEmpty(publicConfigData)) {
      this.fetchEnv();
      this.fetchPublicAthenaConfigs();
    } else {
      this.setState({ isLoading: false });
    }
  }

  fetchEnv = async () => {
    try {
      const response = await proxyAPIs.getEnvironment();
      const env = get(response, 'data.env', 'DEV');
      setWindowObjectKey('env', env);
    } catch (error) {
      console.error('Error in fetching env ::', error);
    }
  };

  fetchPublicAthenaConfigs = async () => {
    const { setPublicConfigs, user } = this.props;
    this.setState({ isLoading: true });
    try {
      if (athenaFeatures.length > 0) {
        const userId = get(user, 'userId', '');
        const payload = {
          name: athenaFeatures,
          userParams: {
            userId: userId,
          },
        };
        const { data = [] } = await configAPIs.fetchPublicFeatureConfig(payload);
        const configs = getConfigs(data);
        setPublicConfigs({ publicConfigData: { ...configs } });
      }
    } catch (error) {
      console.error('Error in fetching configs ::', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { isLoading } = this.state;
    if (isLoading) {
      return (
        <AppWrapper>
          <DefaultBackground>
            <AppLoader />
          </DefaultBackground>
        </AppWrapper>
      );
    }

    return this.props.children;
  }
}

PublicConfigWrapper.propTypes = {
  setPublicConfigs: PropTypes.func,
  config: PropTypes.object,
};

const mapStateToProps = state => {
  const user = get(state, 'user', {});
  const config = get(state, 'config', {});
  const publicConfigData = get(config, 'publicConfigData', {});
  return { user, config, publicConfigData };
};

const mapDisaptchToProps = dispatch => ({
  setPublicConfigs: payload => dispatch(actionsCreator.STORE_PUBLIC_CONFIG(payload)),
});

export default connect(mapStateToProps, mapDisaptchToProps)(PublicConfigWrapper);
